export default class SegmentCreateCtrl {
    constructor($scope, $filter, $state, SweetAlert, SideMenu, Events, Rest, Tag, Segment, Translate) {
        SideMenu.setActive('tag');

        this._filter = $filter;
        this._state = $state;

        this.sweetAlert = SweetAlert;
        this.segmentRepo = Segment;
        this.eventHandler = Events;

        this.segment = {
            name: 'New',
            description: '',
            tags: []
        };
        this.showInfo = true;
        this.loadedTags = [];

        this.defaultName = this.segment.name;

        this.segmentRepo.all().then( response => {
           this.allSegmentsNames = response.data.map(segment => segment.name);
           this.segment.name = this._filter('getNumberedName')(this.allSegmentsNames, 'New');
        });
    }

    createSegment() {
        if (! this.segment.tags.length) {
            return this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                text: this._filter('translate')('SEGMENTATION:FLASH:TAG_ERROR'),
                type: 'error'
            });
        }

        this.segmentRepo.store(this.segment.name, this.segment.description, this.segment.tags).then((segment) => {
            this._state.go('filter.show', { id: segment.data.id, isNew: true });
            this.eventHandler.flashEvent('notification', this._filter('translate')('SEGMENTATION:FLASH:CREATE'));
        }, error => {
            let errorMessage = this._filter('translate')('SEGMENTATION:FLASH:CREATE_ERROR');
            if (error.data && error.data.code === 9) {
                errorMessage = error.data.message || errorMessage;
            }
            this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                text: errorMessage,
                type: 'error'
            });
        })
    };

    combineSegments() {
        if (! this.segment.tags.length) {
            return this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                text: this._filter('translate')('SEGMENTATION:FLASH:TAG_ERROR'),
                type: 'error'
            });
        }

        this.segmentRepo.store(this.segment.name, this.segment.description, this.segment.tags).then((segment) => {
            segment = segment.data;
            segment.tags = this.segment.tags;

            segment.structure = {
                rules: { groups: { key: 'and', segments: []} }
            };

            this.segmentRepo.update(segment, false, false, false).then(() => {
                this._state.go('filter.show', { id: segment.id });
                this.eventHandler.flashEvent('notification', this._filter('translate')('SEGMENTATION:FLASH:CREATE'));
            });
        }, () => {
            this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                text: this._filter('translate')('SEGMENTATION:FLASH:CREATE_ERROR'),
                type: 'error'
            });
        });
    };

    emptyCheck() {
        if (! this.segment.name.length) {
            this.segment.name = this.defaultName;
            return this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                text: this._filter('translate')('SEGMENTATION:FLASH:EMPTY_NAME'),
                type: 'error'
            });
        }
    }

    toggleShowInfo() {
        this.showInfo = ! this.showInfo;
    };
}
